export default __webpack_public_path__ + "logo-trusted-3479b32c1c046474b3006ba9d39a6a4a.svg";